import type { LPSettlementInstructionStatusEnum, SettlementInstructionDirectionEnum } from '@talos/kyoko';
import { EllipsisBoxWithTooltip, Icon, Text } from '@talos/kyoko';
import { memo } from 'react';
import type { DefaultTheme } from 'styled-components';
import { getDetailedLPAssetStatus, getLPAssetStatusMapping } from '../utils/lpAssetStatusMapping';
import { getInstructionStatusDisplayText } from '../utils/lpSettlementInstructionActions';

interface LPInstructionStatusRendererProps {
  theme: DefaultTheme;
  status: LPSettlementInstructionStatusEnum;
  direction: SettlementInstructionDirectionEnum;
  errorText: string | null;
}

export const LPInstructionStatusRenderer = memo(
  ({ theme, status, direction, errorText }: LPInstructionStatusRendererProps) => {
    const detailedStatus = getDetailedLPAssetStatus(status, direction);

    // If no detailed status mapping, just show the raw status
    if (!detailedStatus) {
      return <Text>{status}</Text>;
    }

    const statusMapping = getLPAssetStatusMapping(detailedStatus, theme);

    if (!statusMapping) {
      return <Text>{status}</Text>;
    }

    const displayText = getInstructionStatusDisplayText(status, direction, errorText);

    return (
      <EllipsisBoxWithTooltip
        prefixNode={<Icon icon={statusMapping.icon} size={16} color={statusMapping.color} />}
        tooltipProps={{ placement: 'bottom-start' }}
        data-testid="lp-instruction-status-text"
      >
        {displayText}
      </EllipsisBoxWithTooltip>
    );
  }
);
